import { SlideQuestionErrorKeys } from './keys'
import { type ValidationError, type Validator } from './types'

export const validatePopUpInstructions: Validator = async (_, question) => {
  const errors: ValidationError[] = []

  // Validate popUpTitle
  if (!question.popUpTitle?.trim()) {
    errors.push({
      field: 'popUpTitle',
      key: SlideQuestionErrorKeys.question_pop_up_instructions_title_missing,
    })
  }

  // Validate popUpInstructions
  if (!question.popUpInstructions?.trim()) {
    errors.push({
      field: 'popUpInstructions',
      key: SlideQuestionErrorKeys.question_pop_up_instructions_content_missing,
    })
  }

  // Validate popUpIcon
  if (!question.popUpIcon) {
    errors.push({
      field: 'popUpIcon',
      key: SlideQuestionErrorKeys.question_pop_up_instructions_icon_missing,
    })
  }

  // Validate popUpButtonLabel
  if (!question.popUpButtonLabel?.trim()) {
    errors.push({
      field: 'popUpButtonLabel',
      key: SlideQuestionErrorKeys.question_pop_up_instructions_button_label_missing,
    })
  }

  return errors
}
